<template>
  <!-- 営業所一覧 -->
  <div id="AppMasterListOffice">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">営業所一覧</label>
        </div>
      </div>
      <template :filterConditions="filterConditions">
        <div class="columns">
          <div class="column">
            <div class="field box is-floating-label">
              <label class="label">絞込条件</label>
              <!-- 1行目 -->
              <div class="columns">
                <div class="column is-one-fifth">
                  <b-field label="エリアコード" labelPosition="on-border">
                    <b-input v-model="filterConditions.areaCode"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-fifth">
                  <b-field label="エリア名" labelPosition="on-border">
                    <b-input v-model="filterConditions.areaName"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-fifth">
                  <b-field label="ブロックコード" labelPosition="on-border">
                    <b-input v-model="filterConditions.blockCode"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-fifth">
                  <b-field label="ブロック名" labelPosition="on-border">
                    <b-input v-model="filterConditions.blockName"></b-input>
                  </b-field>
                </div>
              </div>
              <!-- 2行目 -->
              <div class="columns">
                <div class="column is-one-fifth">
                  <b-field label="営業所コード" labelPosition="on-border">
                    <b-input v-model="filterConditions.officeCode"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-fifth">
                  <b-field label="営業所名" labelPosition="on-border">
                    <b-input v-model="filterConditions.officeName"></b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-button
                    style="float:right;"
                    class="button"
                    type="is-primary"
                    icon-right="filter"
                    native-type="button"
                    @click="filter()"
                  >絞り込み</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="columns">
        <div class="column">
          <b-field horizontal label="表示件数" style="float:right; white-space:nowrap;">
            <b-select position="is-right" v-model="perPage">
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div>
        <b-table
          :data="data"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :pagination-size="paginationSize"
          :default-sort-direction="defaultSortDirection"
          default-sort="branchCode"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column
              field="areaCode"
              label="エリアコード"
              sortable
              centered
            >{{ props.row.areaCode }}</b-table-column>
            <b-table-column field="areaName" label="エリア名" sortable>{{ props.row.areaName }}</b-table-column>
            <b-table-column
              field="blockCode"
              label="ブロックコード"
              sortable
              centered
            >{{ props.row.blockCode }}</b-table-column>
            <b-table-column field="blockName" label="ブロック名" sortable>{{ props.row.blockName }}</b-table-column>
            <b-table-column
              field="officeCode"
              label="営業所コード"
              sortable
              centered
            >{{ props.row.officeCode }}</b-table-column>
            <b-table-column field="officeName" label="営業所名" sortable>{{ props.row.officeName }}</b-table-column>
            <b-table-column field="prefectures" label="管轄都道府県" sortable>
              <option
                v-for="prefectures in getLocalPrefectures(props.row.prefectures)"
                :value="prefectures"
                :key="prefectures"
              >{{ prefectures }}</option>
            </b-table-column>
            <b-table-column field="zipCode" label="郵便番号" sortable>{{ props.row.zipCode }}</b-table-column>
            <b-table-column field="address" label="住所" sortable>{{ props.row.address }}</b-table-column>
            <b-table-column field="phoneNumber" label="電話番号" sortable>{{ props.row.phoneNumber }}</b-table-column>
            <b-table-column
              field="salesOfficeMail"
              label="営業所メールアドレス"
              sortable
            >{{ props.row.salesOfficeMail }}</b-table-column>
            <b-table-column
              field="noticeFlg"
              label="通知"
              sortable
            >{{ props.row.noticeFlg | noticeFlgFilter()}}</b-table-column>
          </template>
        </b-table>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
var data = [];
export default {
  name: "AppMasterListOffice",
  methods: {
    getLocalPrefectures: function(value) {
      return value.split(",");
    },
    filter: function() {
      var excuteApi = this.getOfficeListPOST;
      var successCallBack = this.getOfficeListSuccess;
      var errorCallBack = this.getOfficeListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getOfficeListPOST: function(client) {
      return client.apis.apiMaster.getOfficeListPOST({
        body: {
          areaCode: this.filterConditions.areaCode,
          areaName: this.filterConditions.areaName,
          blockCode: this.filterConditions.blockCode,
          blockName: this.filterConditions.blockName,
          officeCode: this.filterConditions.officeCode,
          officeName: this.filterConditions.officeName
        }
      });
    },
    getOfficeListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
    },
    getOfficeListError: function(result) {
      this.showErrorMessage(result);
    }
  },
  data() {
    return {
      data,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 100,
      filterConditions: {
        areaCode: "",
        areaName: "",
        blockCode: "",
        blockName: "",
        officeCode: "",
        officeName: ""
      }
    };
  },
  filters: {
    noticeFlgFilter: function(value) {
      if (value === "0") {
        return "不要";
      } else {
        return "要";
      }
    }
  },
  components: {},
  mounted: function() {
    // WebApi Call
    this.filter(this.filterConditions);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppMasterListOffice.vue